import {FormInput, FormBoolean, Modal} from "@frostbyte-technologies/frostbyte-tailwind";
import React, {Component} from "react";
import {Formik} from "formik";
import * as Yup from "yup";
import {setupReduxConnection} from "../../../redux";
import {request} from "../../../utils/request";

class ProcessingFeesModal extends Component {
  open() {
    this.setState({}, () => {
      this.formikRef && this.formikRef.resetForm();
      this.modal.open();
    });
  }

  handleSubmit = async (values) => {
    const {menuMarkupPercentPOS, menuMarkupPercentOAPP, menuMarkupPercentOWEB} = values;

    let payload = {
      MENU_MARKUP_PERCENT_POS: menuMarkupPercentPOS,
      MENU_MARKUP_PERCENT_OAPP: menuMarkupPercentOAPP,
      MENU_MARKUP_PERCENT_OWEB: menuMarkupPercentOWEB,
      // CASH_DISCOUNT_ENABLED: cashDiscountEnabled,
    };

    await request("partner/settings/v2", "PATCH", {SETTINGS: payload});

    let settings = await request("settings/shop", "GET");

    this.props.updateShop({settings});
    this.modal.close();
  };

  render() {
    const {
      MENU_MARKUP_PERCENT_POS,
      MENU_MARKUP_PERCENT_OAPP,
      MENU_MARKUP_PERCENT_OWEB,
      // CASH_DISCOUNT_ENABLED,
    } = this.props.shop.settings;

    const initialValues = {
      menuMarkupPercentPOS: MENU_MARKUP_PERCENT_POS,
      menuMarkupPercentOAPP: MENU_MARKUP_PERCENT_OAPP,
      menuMarkupPercentOWEB: MENU_MARKUP_PERCENT_OWEB,
      // cashDiscountEnabled: CASH_DISCOUNT_ENABLED,
    };

    const validationSchema = Yup.object().shape({
      menuMarkupPercentPOS: Yup.number().required("Required").min(0).max(100),
      menuMarkupPercentOAPP: Yup.number().required("Required").min(0).max(100),
      menuMarkupPercentOWEB: Yup.number().required("Required").min(0).max(100),
      // cashDiscountEnabled: Yup.bool().required("Required"),
    });
    return (
      <Modal
        label="Menu Markup Settings"
        buttonLabel={"Save"}
        formikOnClick={() => this.formikRef}
        ref={(e) => (this.modal = e)}
      >
        <Formik
          onSubmit={this.handleSubmit}
          innerRef={(e) => (this.formikRef = e)}
          initialValues={initialValues}
          validationSchema={validationSchema}
        >
          {(formikOptions) => {
            const {handleSubmit} = formikOptions;

            return (
              <form onSubmit={handleSubmit}>
                {/* <FormBoolean */}
                {/*   name={"cashDiscountEnabled"} */}
                {/*   label={"Cash Discount Enabled"} */}
                {/*   options={formikOptions} */}
                {/* /> */}
                <FormInput
                  name={"menuMarkupPercentPOS"}
                  label={"Markup Percent (POS)"}
                  options={formikOptions}
                />

                <FormInput
                  name={"menuMarkupPercentOWEB"}
                  label={"Markup Percent (OWEB)"}
                  options={formikOptions}
                />

                <FormInput
                  name={"menuMarkupPercentOAPP"}
                  label={"Markup Percent (OAPP)"}
                  options={formikOptions}
                />
              </form>
            );
          }}
        </Formik>
      </Modal>
    );
  }
}

export default setupReduxConnection(["shop"], null, {forwardRef: true})(ProcessingFeesModal);
